import React, { createContext, useContext, useEffect, useState } from 'react';
import { usePage, router } from '@inertiajs/react'; // o '@inertiajs/inertia-react' dependiendo de tu versión
import { Local } from 'sode-extend-react/sources/storage'
import Swal from 'sweetalert2' 

// 1. Creamos el objeto Context
const HeaderContext = createContext(null);

// 2. Creamos el Provider
export function HeaderProvider({ children }) {
  const { props, url: currentUrl } = usePage();
  const [hasComplementos, setHasComplementos] = useState()
  const [isUploading, setIsUploading] = useState(false); // maneja el loading de la pagina del detalle de producto 
  const [detallePedido, setDetallePedido] = useState({  // maneja el pedido que se ha de registrar en el detalle del producto 
    fecha: '',
    horario: '',
    opcion: '',
    complementos: [],
    imagen: '',
  });

  const [dedicatoria, setDedicatoria] = useState({ //maneja de manera global la dedicatoria
    message: '',
    to: '',
    from: '',
    img: {
      id: null,
      url: null
    }
  });

  const [imgDedicatoria, setImageDedicatoria] = useState({
    id: null,
    url: null
  })

  /* maneja los sasbores de los pasteles  */
  const [kekeSabor, setKekeSabor] = useState(null)
  const [kekeRelleno, setKekeRelleno] = useState(null)

  const {
    auth,
    puntosData,
    tipoFlores,
    submenucategorias,
    general1,
    appUrl,
    upsellCatalog
  } = props;

  const [cartItems, setCartItems] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = Local.get('carrito') || [];
      return saved
    }
    return [];
  });

  const [isCartOpen, setIsCartOpen] = useState(false);
  const [contarItems, setContarItems] = useState(0)

  useEffect(() => {
    if (isCartOpen && !upsellCatalog && cartItems.length > 0) {

      const cartIds = cartItems.map((item) => {
        if (item.tipo !== 'Complemento') {
          return item.id
        }
      });
      console.log(cartIds)

      router.reload({
        only: ['upsellCatalog'],
        data: { cart_ids: cartIds },
        preserveScroll: true,
        preserveState: true,
      });
    }
  }, [isCartOpen, upsellCatalog, cartItems]);


  useEffect(() => {

    Local.set('carrito', cartItems)
    mostrarTotalItems()
  }, [cartItems]);

  const calcularPuntos = () => {
    let articulos = cartItems
    let totalPoints = 0
    for (const item of articulos) {
      if (item.usePoints) {
        totalPoints += item.points * item.cantidad
      }
    }

    console.log(totalPoints)
    return totalPoints
  }



  const mostrarTotalItems = () => {
    let articulos = Local.get('carrito') || []
    let contarArticulos = articulos.reduce((total, articulo) => {
      return total + articulo.cantidad;
    }, 0);
    setContarItems(contarArticulos)

  }
  const deleteItem = (id, usePoints = false) => {
    let articulosCarrito = Local.get('carrito') || [];
    const asignaPuntos = Boolean(usePoints);

    // Filtramos para eliminar únicamente la variante exacta (ID + usePoints)
    const carritoActualizado = articulosCarrito.filter(
      item => !(item.id === id && Boolean(item.usePoints) === asignaPuntos)
    );

    // Guardar estado y almacenamiento local
    Local.set('carrito', carritoActualizado);
    setCartItems(carritoActualizado);
  };

  const addOnCarBtn = (id, usePoints = false) => {
    let articulosCarrito = Local.get('carrito') || [];

    // 1. Calculamos los puntos que ya están comprometidos en el carrito
    const puntosUsadosEnCarrito = articulosCarrito.reduce((total, item) => {
      // Solo sumamos los puntos de aquellos ítems marcados con usePoints: true
      if (item.usePoints) {
        const pts = Number(item.points || item.puntos_complemento || 0) * Number(item.cantidad || 1);
        return total + pts;
      }
      return total;
    }, 0);

    // 2. Puntos disponibles reales
    const puntosDisponibles = Number(auth.points || 0) - puntosUsadosEnCarrito;

    // 3. Normalizamos la bandera enviada
    const asignaPuntos = Boolean(usePoints);

    // 4. Si se intenta incrementar un ítem pagado con puntos, verificamos si le alcanzan
    if (asignaPuntos) {
      const itemTarget = articulosCarrito.find(
        item => item.id === id && Boolean(item.usePoints) === true
      );
      const costoPuntos = Number(itemTarget?.points || itemTarget?.puntos_complemento || 0);

      if (costoPuntos > 0 && puntosDisponibles < costoPuntos) {
        Swal.fire({
          icon: 'warning',
          title: 'Puntos insuficientes',
          text: `No tienes suficientes puntos disponibles (${puntosDisponibles} pts) para agregar otro complemento de ${costoPuntos} pts.`,
        });
        return; // Detener incremento si no hay saldo
      }
    }

    // 5. Actualizamos únicamente la coincidencia exacta de ID y usePoints
    const prodRepetido = articulosCarrito.map(item => {
      const mismoId = item.id === id;
      const mismoUsoPuntos = Boolean(item.usePoints) === asignaPuntos;

      if (mismoId && mismoUsoPuntos) {
        return {
          ...item,
          cantidad: item.cantidad + 1
        };
      }
      return item;
    });

    // 6. Guardar estado y almacenamiento local
    Local.set('carrito', prodRepetido);
    setCartItems(prodRepetido);
  };

  const deleteOnCarBtn = (id, usePoints = false) => {
    let articulosCarrito = Local.get('carrito') || [];
    const asignaPuntos = Boolean(usePoints);

    // 1. Descontamos la cantidad solo a la variante exacta
    let prodRepetido = articulosCarrito.map(item => {
      const mismoId = item.id === id;
      const mismoUsoPuntos = Boolean(item.usePoints) === asignaPuntos;

      if (mismoId && mismoUsoPuntos && item.cantidad > 0) {
        return {
          ...item,
          cantidad: item.cantidad - 1
        };
      }
      return item;
    });

    // 2. Filtramos los artículos que hayan llegado a 0
    const carritoActualizado = prodRepetido.filter(item => item.cantidad > 0);

    // 3. Actualizamos almacenamiento local y estado de React
    Local.set('carrito', carritoActualizado);
    setCartItems(carritoActualizado);
  };

  // Creamos el valor que compartiremos
  const value = {
    auth,
    puntosData,
    tipoFlores,
    submenucategorias,
    general1,
    appUrl,
    currentUrl,
    upsellCatalog,
    isUploading,
    setIsUploading,
    detallePedido,
    setDetallePedido,
    dedicatoria,
    setDedicatoria,
    imgDedicatoria,
    setImageDedicatoria,
    kekeSabor,
    setKekeSabor,
    kekeRelleno,
    setKekeRelleno,

    // Estado y Métodos del Carrito
    cartItems,
    isCartOpen,
    setIsCartOpen,
    setCartItems,
    contarItems,
    deleteItem,
    addOnCarBtn,
    deleteOnCarBtn,
    calcularPuntos,




  };

  return (
    <HeaderContext.Provider value={value}>
      {children}
    </HeaderContext.Provider>
  );
}

// 3. Hook personalizado para consumir el contexto fácilmente
export function useHeaderContext() {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext debe usarse dentro de un HeaderProvider');
  }
  return context;
}